export default __webpack_public_path__ + "static/bg-4e0b8f97c117819b7707bc4c08d07e81.jpg";